const closeButtonLabel = "Fermer";
const frFR = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  frFR as default
};
